import { FireOutlined} from '@ant-design/icons';
export const InterfaceGrade =  {
        1: <FireOutlined />,
        2: <FireOutlined  />,
        3: <FireOutlined  />,
        4: <FireOutlined  />,
        5: <FireOutlined  />,
    };